import React, { useCallback } from 'react'
import { Controller } from 'react-hook-form'
import { Select, Spin } from 'antd'
import PropTypes from 'prop-types'

import styles from '../index.module.scss'
import { StyledFormItem } from '../styles'

const SelectForm = ({
	name,
	label,
	control,
	required = false,
	resolvedRules,
	placeholder,
	customOnChange,
	watchValues,
	allowClear = true,
	options = [],
	isLoading = false,
	mode,
}) => {
	const getSelectOptions = useCallback(() => {
		if (options?.some((option) => !option)) return

		return (
			<>
				{options.map((option) => {
					const key = option.id ?? option.value
					const value = option.id ?? option.value
					const label = option.name ?? option.label
					return (
						<Select.Option key={key} value={value}>
							{label}
						</Select.Option>
					)
				})}
			</>
		)
	}, [options])

	return (
		<StyledFormItem required={required}>
			<p className={styles.label}>
				{label} {required && <span style={{ color: 'red' }}>*</span>}
			</p>
			<Controller
				name={name}
				control={control}
				rules={resolvedRules}
				render={({ field, fieldState }) => (
					<>
						<Select
							{...field}
							mode={mode}
							placeholder={placeholder}
							onChange={(value) =>
								customOnChange
									? customOnChange(value, field.onChange, { watchValues })
									: field.onChange(value)
							}
							disabled={isLoading}
							allowClear={allowClear}
							notFoundContent={isLoading ? <Spin size="small" /> : null}>
							{getSelectOptions(options)}
						</Select>
						{fieldState.error && (
							<span className={styles.errorMessage}>
								{fieldState.error.message}
							</span>
						)}
					</>
				)}
			/>
		</StyledFormItem>
	)
}

SelectForm.propTypes = {
	name: PropTypes.string,
	label: PropTypes.string,
	control: PropTypes.object,
	required: PropTypes.bool,
	requestProps: PropTypes.shape({
		route: PropTypes.string,
	}),
	fieldProps: PropTypes.object,
}

export default SelectForm
